module.exports = __webpack_public_path__ + "img/logo.f2be9939.png";